import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { CustomErrorStateMatcher } from 'src/app/validators/state-matcher/custom-error-state-matcher';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { validPasswordFormat } from 'src/app/validators/password/password.validator';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.css']
})
export class NewPasswordComponent implements OnInit {

  constructor( private formBuilder: FormBuilder,
               private authService: AuthService,
               private notificationToastService: NotificationToastService ) {

    this.form = this.formBuilder.group({
      ActualPassword: ['', Validators.required],
      NewPassword: ['', [ Validators.required,  validPasswordFormat]],
      ConfirmPassword: ['', Validators.required]
    }, { validator: this.checkPasswords });

  }

  @Output() passChanged = new EventEmitter<boolean>();
  userId: number;
  form: FormGroup;
  matcher = new CustomErrorStateMatcher();
  loading: boolean;

  ngOnInit() {
    this.userId = this.authService.getUserId();
  }

  async changePass() {
    try {

      console.log( this.form );
  
      if (this.form.valid) {

        this.loading = true;
        await this.authService.changePassword(
            this.userId,
            this.form.value.ActualPassword,
            this.form.value.NewPassword,
            this.form.value.ConfirmPassword);

        this.passChanged.emit(true);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cambio de contraseña');
    } finally {
      this.loading = false;
    }
  }

  checkPasswords(group: FormGroup) {
    const pass = group.controls.NewPassword.value;
    const confirmPass = group.controls.ConfirmPassword.value;
    if (confirmPass) {
      return pass === confirmPass ? null : { notSame: true };
    } else {
      return null;
    }
  }

}
